import React from 'react';
import { shape, string, number, array, object } from 'prop-types';
import { connect } from 'react-redux';

import Trendline from 'components/Trendline';
import SpeedDisplay from 'components/SpeedDisplay';
import NumberDisplay from 'components/NumberDisplay';
import SegmentNameDisplay from 'components/SegmentNameDisplay';

import SpeedTrendIcon from 'components/SpeedTrendIcon';

import styles from './SegmentsListItem.scss';

export function SegmentsListItem({ segment, sortValue, currentHover }) {
  const {
    status,
    id: segmentId,
    speedLastHour,
    travelTimeIndex,
    liveSpeed,
    to: { name: toName },
    from: { name: fromName },
  } = segment;

  const isReporting = status !== 'disconnected';
  const speedTrend = 'up';

  // @TODO move to gql?
  // TTI trend is same as speed but reversed
  const travelTimeLastHour = speedLastHour.map(v => -v);

  const isHovered = Boolean(currentHover && currentHover.id === segmentId);

  return (
    <div className={styles.main}>
      <div className={styles.liveDisplay}>
        {isReporting
          ? <SpeedTrendIcon trend={speedTrend} className={styles.trendIcon} />
          : <div className={styles.statusText}>N/A</div>}
      </div>

      <SegmentNameDisplay
        className={styles.segment}
        fromLocationName={fromName}
        toLocationName={toName}
        status={status}
      />

      <div className={styles.numberDisplay}>
        {sortValue === 'tti'
          ? <NumberDisplay value={travelTimeIndex} status={status} isHovered={isHovered} />
          : <SpeedDisplay value={liveSpeed} status={status} isHovered={isHovered} />}
      </div>

      <div className={styles.trendLine}>
        {sortValue === 'tti'
          ? <Trendline trendData={speedLastHour} width={48} height={27} />
          : <Trendline trendData={travelTimeLastHour} width={48} height={27} />}
      </div>
    </div>
  );
}

SegmentsListItem.propTypes = {
  segment: shape({
    status: string,
    id: string,
    speedLastHour: array,
    travelTimeIndex: number,
    liveSpeed: number,
    to: object,
    from: object,
  }).isRequired,
  sortValue: string.isRequired,
  currentHover: shape({ id: string, type: string }),
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

const ConnectedSegmentsListItem = connect(mapStateToProps)(SegmentsListItem);

export default ConnectedSegmentsListItem;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/SegmentsListItem/index.js